import { ProgramWizardMessage, ProgramWizardMessageId } from './types';

export class ProgramWizardMessagesStore {
  private messages: ProgramWizardMessage[] = [];

  public addMessages(messages: ProgramWizardMessage[]) {
    this.messages = this.messages.concat(messages);
  }
  public clearMessages() {
    this.messages = [];
  }
  public findMessage(id: ProgramWizardMessageId) {
    return !!this.messages.find((msg) => msg.id === id)?.id;
  }
  public removeMessage(id: ProgramWizardMessageId) {
    this.messages = this.messages.filter((msg) => msg.id !== id);
  }
  public addMessage(message: ProgramWizardMessage) {
    this.messages.push(message);
  }
  public getMessages() {
    return this.messages;
  }
}
